import {Component, Input} from "@angular/core";
import {ErrorService} from "./error.service";
import {MultiError} from "./multi-error";
import {handleErrors} from "../misc/handle-errors.decorator";
import {NgSwitch} from "@angular/common";
import {ValidationError} from "./validation-error";
import {MultiValidationError} from "./multi-validation-error";
import {WorkbookMissingColumnsError} from "./workbook-missing-columns-error";
import {CDFValidationError} from "./cdf-validation-error";

type DisplayError = Error | MultiError | ValidationError | MultiValidationError | WorkbookMissingColumnsError |
  CDFValidationError;

@Component({
  selector: "error-display",
  templateUrl: "./error-display.template.pug",
  providers: [NgSwitch],
})
export class ErrorDisplayComponent {
  private _error: DisplayError;
  showError: boolean;
  multi: boolean = false;
  allowSelfAssign: boolean = false;
  selfAssignProjectId: string = "";

  @Input()
  set error(error: DisplayError) {
    this._error = error;
    this.multi = this.isMultiError();
    this.allowSelfAssign = this.error && this.error["projectId"] && this.error["allowSelfAssign"];
    this.selfAssignProjectId = this.error && this.error["projectId"] ? this.error["projectId"] : undefined;
  }

  get error(): DisplayError {
    return this._error;
  }

  static addError(self: ErrorDisplayComponent, error: Error) {
    if (!self.isMultiError()) {
      const tempError = new MultiError("");
      tempError.errors = [self.error];
      self.error = tempError;
    }

    const multiError = self.error as MultiError;

    if (!multiError.errors) multiError.errors = [];

    multiError.errors = [...multiError.errors, error];
  }

  constructor(private errorService: ErrorService) {}

  isMultiError() {
    return this.error && this.error instanceof MultiError;
  }

  @handleErrors({errorProperty: "", scrollToTop: false, onError: ErrorDisplayComponent.addError as any})
  async assignMeToProject() {
    const assigned = await this.errorService.assignUserToProject(this.selfAssignProjectId);
    if (assigned) document.location.reload(true);
  }
}
